/*
注意！注意！1、请求路径必须与后端的RequestMapping一致；2、参数命名必须一致

包含n个接口请求函数的模块
函数的返回值: promise对象
 */
// const BASE_URL = 'https://localhost'
// 在config/index.js proxyTable处配置了跨域
import ajax from './ajax'
// const BASE_URL = '/api'

// 测试使用，生产环境要改为空字符串，需同步修改main.js
// const BASE_URL = '/test'
const BASE_URL = '/local'


/**
 * SMSController
 * 请求发送短信验证码，用于注册 后端是/registerSendCode，不是sendCode
 * @param phone 手机号码
 */
export const reqRegisterSendCode = (phone) => ajax(BASE_URL + '/registerSendCode', {phone})

/**
 * RegisterController
 * 请求保存商家注册信息
 * @param formdata
 * @param config
 */
export const reqRegister = (formdata, config) => ajax(`${BASE_URL}/register`, formdata, 'POST', config)



/**
 * LoginController
 * 请求更新密码
 * @param originPassword 原密码
 * @param password 新密码
 */
export const reqUpdatePassword = (originPassword, password) => ajax(BASE_URL + '/updatePassword', {originPassword, password}, 'POST')

/**
 * LoginController
 * 请求更新登录手机号码
 * @param password 密码
 * @param phone 新手机号
 */
export const reqUpdateLoginPhone = (password, phone) => ajax(BASE_URL + '/updateLoginPhone', {password, phone}, 'POST')

/**
 * CustomerController
 * 请求更新登录手机号码
 * @param password 密码
 * @param email 新邮箱地址
 */
export const reqUpdateEmail = (password, email, code) => ajax(BASE_URL + '/updateEmail', {password, email, code}, 'POST')


/**
 * CustomerController
 * 请求获取客户注册信息
 */
export const reqCustomerInfo = () => ajax(BASE_URL + '/customerInfo')


/**
 * CustomerController
 * 请求更新联系人信息
 * @param managerName 联系人姓名
 * @param managerPhone 联系人手机号码
 */
export const reqUpdateManager = (managerName, managerPhone) => ajax(BASE_URL + '/updateManager', {managerName, managerPhone}, 'POST')

/**
 * LLMController
 * 请求创建产品
 */
export const reqCreateProduct = (subPath, productName, description) => ajax(BASE_URL + '/ali_proxy', {subPath, productName, description}, 'POST')

/**
 * LLMController
 * 请求获取API KEY
 */
export const reqApiKey = () => ajax(BASE_URL + '/apiKey')

/**
 * LLMController
 * 请求获取产品列表
 */
export const reqProductInfo = (subPath, pageIndex, pageSize) => ajax(BASE_URL + '/ali_proxy', {subPath, pageIndex, pageSize}, 'POST')

export const reqProductInfos = (subPath, tenantId, pageIndex, pageSize) => ajax(BASE_URL + '/ali_proxy', {subPath, tenantId, pageIndex, pageSize}, 'POST')


/**
 * LLMController
 * 请求获取产品配额变更列表
 */
export const reqProductQuotaRecord = (subPath, productKey, purchaseType, pageIndex, pageSize) => ajax(BASE_URL + '/ali_proxy', {subPath, productKey, purchaseType, pageIndex, pageSize}, 'POST')

export const reqProductQuotaRecords = (subPath, tenantId, purchaseType, pageIndex, pageSize) => ajax(BASE_URL + '/ali_proxy', {subPath, tenantId, purchaseType, pageIndex, pageSize}, 'POST')

export const reqAliQuotaInfo = (subPath, recordId) => ajax(BASE_URL + '/ali_proxy', {subPath, recordId}, 'POST')


/**
 * LLMController
 * 请求删除产品
 */
export const reqDeleteProduct = (subPath, productKey) => ajax(BASE_URL + '/ali_proxy', {subPath, productKey}, 'POST')


/**
 * LLMController
 * 请求获取统计数据
 */
export const reqStatistics = (subPath, productKey, startData, endData) => ajax(BASE_URL + '/ali_proxy', {subPath, productKey, startData, endData}, 'POST')

/**
 * LLMController
 * 请求获取资源包规格参数列表
 */
export const reqResourceParams = () => ajax(BASE_URL + '/resourceParams')

/**
 * LLMController
 * 请求获取产品到期日期
 */
export const reqProductHasValidResource = () => ajax(BASE_URL + '/productHasValidResource')


/**
 * LLMController
 * 请求获取图片资源包规格参数列表
 */
export const reqResourcePicParams = () => ajax(BASE_URL + '/resourcePicParams')

/**
 * LLMController
 * 请求获取图片资源包规格参数
 */
export const reqResourcePicParam = (aliOrderId) => ajax(BASE_URL + '/resourcePicParam', {aliOrderId})

/**
 * LLMController
 * 请求获取图片资源包规格参数列表，用于升级
 */
export const reqResourcePicParams4Upgrade = (aliOrderId) => ajax(BASE_URL + '/resourcePicParams4Upgrade', {aliOrderId})


/**
 * LLMController
 * 请求获取资源包规格参数
 */
export const reqCalculatePrice = (productKey, purchaseType, tokenNumber, duration, qps, licenseCount, aliOrderId, expireTime) => ajax(BASE_URL + '/calculatePrice', {productKey, purchaseType, tokenNumber, duration, qps, licenseCount, aliOrderId, expireTime}, 'POST')

/**
 * LLMController
 * 请求获取阿里订单的资源配额信息
 */
export const reqQuotaInfo = (aliOrderId) => ajax(BASE_URL + '/quotaInfo', {aliOrderId}, 'POST')

/**
 * LLMController
 * 请求检查当前订单是否续购或升级过
 */
export const reqCheckUpgrade = (aliOrderId) => ajax(BASE_URL + '/isUpgrade', {aliOrderId})



/**
 * MerchantController
 * 请求获取设备列表
 */
export const reqDevice = () => ajax(BASE_URL + '/devices')





/**
 * MerchantController
 * 请求获取应用列表
 */
export const reqApplication = () => ajax(BASE_URL + '/apps')

/**
 * MerchantController
 * 请求获取套餐订单
 */
export const reqProductOrders = () => ajax(BASE_URL + '/productOrders')

/**
 * MerchantController
 * 请求获取客户购买的资源包
 */
export const reqPurchasedResourcePackages = () => ajax(BASE_URL + '/purchasedResPkgs')




/**
 * HelloController
 * 测试请求
 * @param name 手机号码
 * @param age 短信验证码
 */
export const reqHello = (name, age) => ajax(BASE_URL + '/hello2', {name, age})


/**
 * MerchantController
 * 请求获取商家注册信息（通过注册手机号码获取）
 */
export const reqGetRegisterInfoByPhone = (phone) => ajax(BASE_URL + '/getRegisterInfoByPhone', {phone})


/**
 * SMSController
 * 请求发送短信验证码，用于注册 后端是/resetPasswordSendCode，不是sendCode
 * @param phone 手机号码
 */
export const reqResetPasswordSendCode = (phone) => ajax(BASE_URL + '/resetPasswordSendCode', {phone})

/**
 * SMSController
 * 请求发送短信验证码 后端是/sendCode
 * @param phone 手机号码
 */
export const reqSendCode = (phone) => ajax(BASE_URL + '/sendCode', {phone})

/**
 * SMSController
 * 请求发送短信验证码 后端是/sendCode
 * @param phone 手机号码
 */
export const reqSendEmailCode = (email) => ajax(BASE_URL + '/sendEmailCode', {email})


/**
 * SMSController
 * 请求检查注册验证码是否正确
 * @param phone 手机号码
 * @param code 短信验证码
 */
export const reqCheckCode = (phone, code) => ajax(BASE_URL + '/checkCode', {phone, code})

/**
 * LoginController
 * 请求登录系统
 * @param account 登录账号，可以是手机或用户名
 * @param password 密码
 */
export const reqLogin = (account, password, userType) => ajax(BASE_URL + '/login', {account, password, userType}, 'POST')

/**
 * AdminController
 * 请求登录系统
 * @param account 登录账号，可以是手机或用户名
 * @param password 密码
 */
export const reqAdminLogin = (account, password, userType) => ajax(BASE_URL + '/adminLogin', {account, password, userType}, 'POST')

/**
 * AdminController
 * 请求刷新课程缓存
 */
export const reqReCache = () => ajax(BASE_URL + '/reCache', {}, 'POST')

/**
 * AdminController
 * 请求刷新白名单价格
 */
export const reqReloadWhiteList = () => ajax(BASE_URL + '/reloadWhiteList', {}, 'POST')


/**
 * SystemLogoutFilter
 * 请求退出系统
 */
export const reqLogout = () => ajax(BASE_URL + '/logout', {}, 'POST')

/**
 * LoginController
 * 请求登录系统
 * @param phone 手机号码
 * @param code 短信验证码
 * @param loginType 2-消费者登录 1-商家登录
 */
export const reqCheckCodeLogin = (phone, code, loginType) => ajax(BASE_URL + '/checkCodeLogin', {phone, code, loginType}, 'POST')


/**
 * LoginController
 * 请求重置密码
 * @param loginPhone 登录手机号码
 * @param code 验证码
 * @param email 注册邮箱
 */
export const reqResetPassword = (name, loginPhone, code, email) => ajax(BASE_URL + '/resetPassword', {name, loginPhone, code, email}, 'POST')

/**
 * AdminController
 * 请求新增课程笔记打开记录
 * @param name 客户名称
 * @param currentPage 当前页码
 */
export const reqFindAllCustomers = (name, currentPage) => ajax(BASE_URL + '/findAllCustomers', {name, currentPage})

/**
 * OrderController
 * @param name 客户名称
 * @param currentPage 当前页码
 * @returns {Promise | Promise<unknown>}
 */
export const reqFindAllOrders = (name, currentPage) => ajax(BASE_URL + '/findAllOrders', {name, currentPage})

export const reqOrderDetail = (orderId) => ajax(BASE_URL + '/getOrderDetail', {orderId})

export const reqCusOrderDetail = (aliOrderId) => ajax(BASE_URL + '/orderDetail', {aliOrderId})


/**
 * OrderController
 * 请求获取指定客户的订单列表
 * @param loginPhone 客户手机号码
 */
export const reqFindCustomerOrders = () => ajax(BASE_URL + '/findCustomerOrders', {})


/**
 * InvoiceController
 * 请求获取当前用户的发票信息
 * @param formdata
 * @param config
 */
export const reqGetInvoiceInfo = () => ajax(`${BASE_URL}/getInvoiceInfo`, {})

/**
 * InvoiceController
 * 请求开发票
 * @param formdata
 * @param config
 */
export const reqInvoice = (formdata, config) => ajax(`${BASE_URL}/invoice`, formdata, 'POST', config)

/**
 * InvoiceController
 * 请求获取所有发票
 * @param phone 客户手机号码
 * @param currentPage 页号
 */
export const reqFindAllInvoices = (phone, currentPage) => ajax(BASE_URL + '/findAllInvoices', {phone, currentPage})

/**
 * InvoiceController
 * 请求更新发票状态
 * @param phone 客户手机号码
 * @param currentPage 页号
 */
export const reqUpdateInvoice = (id, orderId) => ajax(BASE_URL + '/updateInvoice', {id, orderId}, 'POST')

/**
 * OrderController
 * 请求保存订单
 * @param productKey 产品编号
 * @param settlementAmount 结算金额 单位分
 */
export const reqSaveOrder = (payType, productKey, settlementAmount, purchaseType, tokenNumber, duration, qps, licenseCount, unitPrice, lastAliOrderId, remainMonths, lastTokenNumber, upgradeUnitPrice, note) => ajax(`${BASE_URL}/saveOrder`, {payType, productKey, settlementAmount, purchaseType, tokenNumber, duration, qps, licenseCount, unitPrice, lastAliOrderId, remainMonths, lastTokenNumber, upgradeUnitPrice, note}, 'POST')

export const reqSaveOrder4Pic = (payType, productKey, settlementAmount, resNo, purchaseType, licenseCount, duration, unit, recordId) => ajax(`${BASE_URL}/saveOrder4Pic`, {payType, productKey, settlementAmount, resNo, purchaseType, licenseCount, duration, unit, recordId}, 'POST')

export const reqSaveOrder4PicUpgrade = (payType, productKey, settlementAmount, resNo, purchaseType, licenseCount, duration, unit, recordId, lastAliOrderId, gapUnitPrice) => ajax(`${BASE_URL}/saveOrder4Pic`, {payType, productKey, settlementAmount, resNo, purchaseType, licenseCount, duration, unit, recordId, lastAliOrderId, gapUnitPrice}, 'POST')

/**
 * OrderController
 * 请求检查订单支付状态
 * @param orderNo 订单编号
 */
export const reqCheckPayStatus = (orderNo) => ajax(`${BASE_URL}/checkPayStatus`, {orderNo}, 'POST')



// WEBPACK FOOTER //
// ./src/api/index.js